export function decodeHTML(inputStr: string): string {
  var textarea = document.createElement('textarea');
  textarea.innerHTML = inputStr;

  return textarea.value.replace(/\\<\/?link>/g, '');
}
